export const CATEGORIES_FETCHED_SUCCESS = 'CATEGORIES_FETCHED_SUCCESS';
export const CATEGORIES_ERROR = 'CATEGORIES_ERROR';

export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const FETCH_CATEGORY_BY_ID = 'FETCH_CATEGORY_BY_ID';
export const FETCH_CATEGORY_BY_ID_SUCCESS = 'FETCH_CATEGORY_BY_ID_SUCCESS';

export const SELECT_CATEGORY = 'SELECT_CATEGORY';